module.exports = __webpack_public_path__ + "fonts/fa-solid-900---7a5de9b08012e4da40504f2cf126a351.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-solid-900.svg
// module id = 378
// module chunks = 0